import { Skeleton } from 'antd';
import React, { FC } from 'react';

interface Props {
  size?: 'default' | 'small' | 'large';
}

export const AvatarGroupSkeleton: FC<Props> = ({ size = 'large' }) => (
  <>
    <Skeleton.Avatar size={size} />
    <Skeleton.Avatar
      size={size}
      style={{ marginLeft: -4, border: '1px solid #fff' }}
    />
    <Skeleton.Avatar
      size={size}
      style={{ marginLeft: -4, border: '1px solid #fff' }}
    />
  </>
);
